import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import Meta from 'vue-meta'
import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import { VueHammer } from 'vue2-hammer'
import { setValidateMessages } from '@/scripts/validation'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ru-RU'
// import { updateToken } from '@/plugins/keycloak'
// import Keycloak from 'keycloak-js'

const ValidateMessages = {
  install: Vue => {
    Vue.prototype.$errorMessages = setValidateMessages
  }
}

Vue.config.productionTip = false
Vue.use(ValidateMessages)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueHammer)

Vue.use(Meta, {
  refreshOnceOnNavigation: true
})

Vue.use(ElementUI, { locale })

Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 4000,
})

Vue.prototype.showErrorMessage = (e, msg = 'Error') => {
  let data
  if (e.data instanceof ArrayBuffer) {
    const str = new TextDecoder().decode(e.data)
    data = JSON.parse(str)
  } else {
    data = e.data
  }
  console.log(e)
  const message = e?.status !== 500 && data?.message ? data?.message : msg
  Vue.prototype.$toastr('error', `<b>Код ошибки: ${e.status || 'неизвестный'}</b>`, message)
}

export const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// keycloak вариант 1

// Vue.$keycloak.init({ onLoad: 'login-required' }).then((auth) => {
//   if (!auth) {
//     window.location.reload();
//   } else {
//     new Vue({
//       router,
//       store,
//       vuetify,
//       render: h => h(App)
//     }).$mount('#app')
//
//     window.onfocus = () => {
//       updateToken()
//     }
//   }
// })

//keycloak вариант 2

// let initOptions = {
//   url: 'http://10.1.20.33:8080/', realm: 'zps', clientId: 'zps-client', onLoad: 'login-required'
// }
//
// let keycloak = Keycloak(initOptions)
// Vue.prototype.$keycloak = keycloak
//
// keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
//   if (!auth) {
//     window.location.reload()
//   } else {
//     console.log("Authenticated")
//     //Vue.$log.info("Authenticated")
//
//     new Vue({
//       router,
//       store,
//       vuetify,
//       render: h => h(App , { props: { keycloak: keycloak } })
//     }).$mount('#app')
//   }
//
// //Token Refresh
//   setInterval(() => {
//     keycloak.updateToken(70).then((refreshed) => {
//       if (refreshed) {
//         //Vue.$log.info('Token refreshed' + refreshed)
//         console.log('Token refreshed ' + refreshed)
//       } else {
//         // Vue.$log.warn('Token not refreshed, valid for '
//         //   + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
//         console.log('Token not refreshed, valid for '
//           + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
//       }
//     }).catch(() => {
//       //Vue.$log.error('Failed to refresh token')
//       console.log('Failed to refresh token')
//     })
//   }, 6000)
//
// }).catch(() => {
//   console.log("Authenticated Failed")
//   //Vue.$log.error("Authenticated Failed")
// })
